// extracted by mini-css-extract-plugin
module.exports = {"changePassword":"changePassword_changePassword__3mtyu","centerFormInfo":"changePassword_centerFormInfo__YwRSj","changePasswordForm":"changePassword_changePasswordForm__1uhvm"};